// Helpers to exclude the admin's own activity from Visitors / Analytics.

const FLAG_KEY = "pdn_is_admin";
const SESSIONS_KEY = "pdn_admin_sessions";
const SESSION_KEY = "pdn_session_id";

export function isAdminDevice(): boolean {
  try { return localStorage.getItem(FLAG_KEY) === "1"; } catch { return false; }
}

export function markAdminDevice() {
  try {
    localStorage.setItem(FLAG_KEY, "1");
    const sid = localStorage.getItem(SESSION_KEY);
    if (sid) {
      const list = getAdminSessionIds();
      if (!list.includes(sid)) {
        list.push(sid);
        localStorage.setItem(SESSIONS_KEY, JSON.stringify(list));
      }
    }
  } catch {}
}

export function getAdminSessionIds(): string[] {
  try {
    const raw = localStorage.getItem(SESSIONS_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : [];
  } catch { return []; }
}
